import { useState, useEffect, useCallback } from 'react';
import { fetchWalletBalance } from '@ikhua/shared';
import apiClient from '../utils/apiClient';

export default function useBalance(chain, address) {
  const [balance, setBalance] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchBalance = useCallback(async () => {
    if (!address) return;
    setIsLoading(true);
    try {
      const balance = await fetchWalletBalance(apiClient, chain, address);
      setBalance(balance);
    } catch (error) {
      console.error('Balance fetch error:', error);
    } finally {
      setIsLoading(false);
    }
  }, [chain, address]);

  // Initial fetch + periodic refresh
  useEffect(() => {
    fetchBalance(); // Immediate fetch
    const interval = setInterval(fetchBalance, 1200000);
    return () => clearInterval(interval);
  }, [fetchBalance]);

  return { balance, isLoading, refresh: fetchBalance };
}
